import { List } from 'foundations-components/transitional/components/List';
import FileDraftErrorsListItem from './FileDraftErrorsListItem';
import { jsx as _jsx } from "react/jsx-runtime";
const FileDraftErrorsList = ({
  fileDraftsErrorsMap,
  onRemove
}) => /*#__PURE__*/_jsx(List, {
  children: Array.from(fileDraftsErrorsMap.entries()).map(([file, {
    errorType
  }]) => /*#__PURE__*/_jsx(FileDraftErrorsListItem, {
    file: file,
    errorType: errorType,
    onRemove: onRemove
  }, file.name))
});
export default FileDraftErrorsList;